import About from "../pages/About";
import Blog from "../pages/Blog";
import BlogDetail from "../pages/Blog/components/Detail";
import Home from "../pages/Home";
import MyProject from "../pages/MyProject";
import MyTeam from "../pages/MyTeam";
import Privacy from "../pages/Privacy";
import Project from "../pages/Project";
import Detail from "../pages/Project/components/Detail";
import Share from "../pages/Share";
import Terms from "../pages/Terms";
import Tutorial from "../pages/Tutorial";
import TutorialDetail from "../pages/Tutorial/components/Detail";
import User from "../pages/User";
import UserMenu from "../pages/UserMenu";
import Wallet from "../pages/Wallet";
import Trade from "../pages/Wallet/components/Trade";

const RouterList = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/project",
    name: "project",
    component: Project,
    navType: {
      center: {
        title: "footer.item.project",
        hasBack: false,
      },
    },
  },
  {
    path: "/project/:id",
    name: "detail",
    component: Detail,
    navType: {
      hideFooter: true,
      center: {
        title: "footer.item.project",
        hasBack: true,
      },
    },
  },
  {
    path: "/share",
    name: "share",
    component: Share,
    navType: {
      backgroundColor: "#000",
      center: {
        title: "footer.item.share",
        hasBack: false,
      },
    },
  },
  {
    path: "/user",
    name: "user",
    component: UserMenu,
    navType: {
      backgroundColor: "#000",
      center: {
        title: "footer.item.user",
        hasBack: false,
      },
    },
  },
  {
    path: "/user/bank-info",
    name: "bankInfo",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "user.bankInfo",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/withdrawAddress",
    name: "withdrawAddress",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "user.withdrawAddress",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/gift",
    name: "gift",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.gift",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/my-income",
    name: "myIncome",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "user.myIncome",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/safe",
    name: "safe",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "user.safe",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/my-project",
    name: "myProject",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "nav.myProject",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/my-team",
    name: "myTeam",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "nav.myTeam",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/recharge/recharge",
    name: "recharge",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.recharge",
        hasBack: true,
        rightText: "normal.record.upper",
        rightUrl: "/user/recharge/record?tab=recharge&radioValue=record",
      },
    },
  },
  {
    path: "/user/recharge/record",
    name: "record",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.recharge",
        hasBack: true,
      },
    },
  },
  {
    path: "/user/recharge/recharge/:id",
    name: "trade",
    component: Trade,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.recharge",
        hasBack: false,
      },
    },
  },
  {
    path: "/user/withdraw/withdraw",
    name: "withdraw",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.withdraw",
        hasBack: true,
        rightText: "normal.record.upper",
        rightUrl: "/user/withdraw/record?tab=withdraw&radioValue=record",
      },
    },
  },
  {
    path: "/user/withdraw/record",
    name: "record",
    component: User,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.withdraw",
        hasBack: true,
      },
    },
  },
  {
    path: "/wallet/recharge/recharge",
    name: "recharge",
    component: Wallet,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.recharge",
        hasBack: true,
        rightText: "normal.record.upper",
        rightUrl: "/wallet/recharge/record?tab=recharge&radioValue=record",
      },
    },
  },
  {
    path: "/wallet/recharge/recharge/:id",
    name: "trade",
    component: Trade,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.recharge",
        hasBack: false,
      },
    },
  },
  {
    path: "/wallet/recharge/record",
    name: "rechargeRecord",
    component: Wallet,
    navType: {
      hideFooter: true,
      center: {
        title: "wallet.recharge.record",
        hasBack: true,
      },
    },
  },
  {
    path: "/wallet/withdraw/withdraw",
    name: "withdraw",
    component: Wallet,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.withdraw",
        hasBack: true,
        rightText: "normal.record.upper",
        rightUrl: "/wallet/withdraw/record?tab=withdraw&radioValue=record",
      },
    },
  },
  {
    path: "/wallet/withdraw/record",
    name: "withdrawRecord",
    component: Wallet,
    navType: {
      hideFooter: true,
      center: {
        title: "wallet.withdraw.record",
        hasBack: true,
      },
    },
  },
  {
    path: "/my-team",
    name: "myTeam",
    component: MyTeam,
    navType: {
      hideFooter: true,
      center: {
        title: "user.myTeam",
        hasBack: true,
      },
    },
  },
  {
    path: "/my-project",
    name: "myProject",
    component: MyProject,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.myProject",
        hasBack: true,
      },
    },
  },
  {
    path: "/blog",
    name: "blog",
    component: Blog,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.blog",
        hasBack: true,
      },
    },
  },
  {
    path: "/blog/:id",
    name: "blog",
    component: BlogDetail,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.blog",
        hasBack: true,
      },
    },
  },
  {
    path: "/about",
    name: "about",
    component: About,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.about",
        hasBack: true,
      },
    },
  },
  {
    path: "/tutorial",
    name: "tutorial",
    component: Tutorial,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.tutorial",
        hasBack: true,
      },
    },
  },
  {
    path: "/tutorial/:id",
    name: "tutorial",
    component: TutorialDetail,
    navType: {
      hideFooter: true,
      center: {
        title: "normal.tutorial",
        hasBack: true,
      },
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy,
    navType: {
      center: {
        title: "footer.item.privacy",
        hasBack: false,
      },
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: Terms,
    navType: {
      center: {
        title: "normal.terms",
        hasBack: false,
      },
    },
  },
];
export default RouterList;
